module.exports = "<pioneer-payment-title-summary\n  [iconClass]=\"'fa-exclamation-triangle'\"\n  [title]=\"errorTitle\"\n  [isCompleted]=\"false\"\n  [summary]=\"errorSummary\">\n</pioneer-payment-title-summary>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-error/payment-error.component.html
// module id = 8w4W
// module chunks = 0